import {
  Cable,
  Database,
  FileJson,
  Globe,
  LayoutDashboard,
  Network,
  ShieldAlert,
  UploadCloud,
  UsersRound,
} from "lucide-react";

export const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard-link" },
  { to: "/arquitectura-v2", label: "Arquitectura V2", icon: Database, testid: "nav-v2-link" },
  { to: "/alertas-v2", label: "Alertas V2", icon: ShieldAlert, testid: "nav-v2-alerts-link" },
  { to: "/collector-v2", label: "Collector V2", icon: Cable, testid: "nav-v2-collector-link" },
  { to: "/importar", label: "Importar", icon: UploadCloud, testid: "nav-import-link" },
  { to: "/manos", label: "Manos", icon: FileJson, testid: "nav-hands-link" },
  { to: "/jugadores", label: "Jugadores", icon: UsersRound, testid: "nav-players-link" },
  { to: "/relaciones", label: "Relaciones", icon: Network, testid: "nav-relationships-link" },
  { to: "/network", label: "Network Graph", icon: Globe, testid: "nav-network-graph-link" },
];

export const riskLabels = {
  info: "Info",
  low: "Bajo",
  medium: "Medio",
  high: "Alto",
  critical: "Crítico",
};

export const signalLabels = {
  timing_bot: "Bot / timing",
  chip_dumping: "Chip dumping",
  chipdumping_pair: "Chip dumping pair",
  collusion_pair_softplay: "Collusion softplay",
  team_cluster: "Team cluster",
  bot_player_timing: "Bot timing",
  bot_player_metronome: "Bot metronome",
  bot_collusion_cluster: "Bot-collusion",
  team_profit_vs_field: "Team profit vs field",
  collusion: "Collusion",
  multi_account: "Multi-account",
  parser_warning: "Parser",
  single_hand_limit: "Muestra pequeña",
};
